import { CLIENT_APP_VERSION, CLIENT_BUILD_ID } from "./generated/appBuildMeta";

/** Версия для заголовков и heartbeat (задаётся при сборке, см. scripts/write-app-version.cjs). */
export const APP_VERSION = CLIENT_APP_VERSION;

/** Идентификатор сборки: сверяется с /app-version.json на сервере. */
export const BUILD_ID = CLIENT_BUILD_ID;
